export const FINAL_PRICE_TEXTS = {
    BACK_BUTTON: "Regresar",
    MODALITY_TEXT: "Este es el resultado para la modalidad de:",
    SERVICE_TYPES: {
        SHOPPER: "PERSONAL SHOPPER",
        LOCKER: "CASILLERO"
    },
    TITLE: {
        MAIN: "¿Lo viste? ¡Lo hicimos de nuevo!",
        SUB: "Un SÚPER precio para un SÚPER servicio"
    },
    PRICE_INFO: {
        FINAL_VALUE: "Este es el valor final que pagarías hasta tu casa, ni un centavito más*.",
        VALID_FOR: "─── Válido por 24 horas*",
        NO_SURPRISES: "No habrán sorpresas, costos ocultos, reajustes por parte de terceros o cualquier cosa que se te ocurra. Este costo lo",
        INCLUDES_ALL: "INCLUYE TODO*",
        FROM_MIAMI: "desde Miami a tu casa. Yeiiiii. Si lo prefieres, puedes ver el detalle de este valor",
        CLICK_HERE: "aquí"
    },
    BUTTONS: {
        CREATE_LOCKER: "Crear mi casillero ahora mismo"
    },
    ACCOUNT_INFO: {
        HAVE_ACCOUNT: "¿Ya tienes una Wuuju-cuenta?.",
        LOGIN: "Inicia sesión"
    },
    DISCLAIMER: "*Podrá verse alterado por la variación en la tasa representativa del mercado T.R.M. del dólar",
    MODAL: {
        TITLE: "CUENTAS CLARAS CHOCOLATE ESPESO",
        TRM_TEXT: "T.R.M 1 USD =",
        COP: "COP",
        SECTIONS: {
            PRODUCT_PRICE: "Precio Producto",
            INTERNATIONAL_SHIPPING: "Envío Internacional",
            LOGISTIC_EXPENSES: "Gastos Logísticos",
            INSURANCE: "Seguro",
            HOME_DELIVERY: "Envío a casa"
        },
        FREE_TEXT: "Gratis",
        BUTTON_TEXT: "Listo"
    }
};